import React from "react";
import { UseFormReturn } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useWindowSize } from "go-core/components/useWindowSize";
import { VenueSettingsApi } from "../../../../../../../../../../../../services/Api/Organization/types";
import { VenueSettingsItemApi } from "../../../../../../../../../../../../services/Api/types";
import { getSettingsKioskBasicTypes, getSettingsTypes } from "../../utils";
import SettingsTable from "../SettingsTable";

interface Props {
	form: UseFormReturn<VenueSettingsApi>;
	search: string;
	settings: VenueSettingsItemApi[];
}

const KioskSettingsBasicCard = ({ form, settings, search }: Props) => {
	const { t } = useTranslation();
	const isMobile = useWindowSize().isMobile;

	return (
		<fieldset className="form-group">
			<div className={`${isMobile ? "table-responsive" : ""}`}>
				<table className={"table table-preview"}>
					<SettingsTable
						types={getSettingsTypes(getSettingsKioskBasicTypes(settings), t, search)}
						form={form}
					/>
				</table>
			</div>
		</fieldset>
	);
};

export default KioskSettingsBasicCard;
